import { Link } from 'react-router-dom'
import { Icon } from '../Icon'
import { AppTourLink } from '../AppTourLink'
import { OrganizationSwitcher } from '../OrganizationSwitcher'
import { UnreadBadge } from '../SideBar/UnreadBadge'
import { sidebarStrings } from '../../constants/strings'
import { branding } from '../../constants/branding'
import { routes } from '../../constants/routes'
import { useOrgPath } from '../../hooks/useOrgPath'
import { useTotalUnreadCount } from '../../hooks'
import {
  MOBILE_HEADER_ICON_SIZE,
  mobileHeaderIconButtonClass,
} from './styles'

type MobileTopBarProps = {
  onOpenMobileNav: () => void
}

export function MobileTopBar({ onOpenMobileNav }: MobileTopBarProps) {
  const { data: totalUnreadCount = 0 } = useTotalUnreadCount()
  const orgPathFor = useOrgPath()

  return (
    <header className="sticky top-0 z-20 flex h-[var(--mobile-topbar-h)] items-center justify-between gap-2 border-b border-white/70 bg-white/85 px-3 backdrop-blur-md lg:hidden">
      <button
        type="button"
        onClick={onOpenMobileNav}
        aria-label={sidebarStrings.mobileNavOpenLabel}
        className={`relative flex ${mobileHeaderIconButtonClass} shrink-0 items-center justify-center rounded-2xl text-ink transition hover:bg-neutral-25`}
      >
        <Icon
          icon="menuBars"
          width={MOBILE_HEADER_ICON_SIZE}
          height={MOBILE_HEADER_ICON_SIZE}
        />
        <UnreadBadge
          count={totalUnreadCount}
          className="absolute right-1 top-1"
        />
      </button>

      <Link
        to={orgPathFor(routes.LINE)}
        aria-label={branding.serviceName}
        className="flex min-w-0 flex-1 items-center justify-center"
      >
        <img
          src={branding.logoUrl}
          alt={branding.serviceName}
          className="h-14 w-auto max-w-full object-contain"
        />
      </Link>

      <div className="flex shrink-0 items-center gap-2">
        <OrganizationSwitcher variant="mobile" />
        <AppTourLink compact />
      </div>
    </header>
  )
}
